import React, { useEffect } from 'react';
import { useAuthStore } from './store/authStore';
import { supabase } from './lib/supabase';
import { LoginForm } from './components/LoginForm';
import { Header } from './components/Header';
import { RecordButton } from './components/RecordButton';
import { TranscriptionBox } from './components/TranscriptionBox';

export default function App() {
  const { isAuthenticated, setUser } = useAuthStore();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setUser(session?.user ?? null);
    });

    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [setUser]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      {!isAuthenticated ? (
        <div className="flex items-center justify-center min-h-screen p-4">
          <LoginForm />
        </div>
      ) : (
        <div className="min-h-screen flex flex-col">
          <div className="container mx-auto px-4 py-4 sm:py-6">
            <Header />
          </div>
          
          <div className="flex-grow flex flex-col items-center justify-between gap-6 container mx-auto px-4 pb-8">
            <TranscriptionBox />
            
            <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-10">
              <RecordButton />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}